import { BadgeCheck, MapPinned, Megaphone, Truck } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import EnquiryForm from "../components/EnquiryForm";
import { Reveal } from "../components/Motion";

import { pick } from "../lib/leadFields";

const FIELDS = pick(
  { name: "name", label: "Full name", required: true },
  "phone", "whatsapp", "email",
  { name: "company", label: "Firm / Business name" }, "business_type",
  { name: "partnership", label: "Interested in", type: "select", required: true, options: ["Dealership", "Distributorship", "Franchise"] },
  { name: "city", label: "City / Town", required: true },
  { name: "district", label: "District" },
  { ...{ name: "state", label: "State", type: "select", required: true }, options: ["West Bengal", "Odisha", "Jharkhand", "Bihar", "Assam", "Uttar Pradesh", "Other"] },
  { name: "business", label: "Current business", placeholder: "e.g. Petrol pump, spare parts shop" },
  { name: "space", label: "Storage space available", type: "select", options: ["Under 200 sq ft", "200–500 sq ft", "500–1000 sq ft", "1000+ sq ft"] },
  { name: "investment", label: "Planned investment", type: "select", options: ["Under ₹2 lakh", "₹2–5 lakh", "₹5–10 lakh", "₹10 lakh+"] },
  { name: "message", label: "Tell us about yourself", type: "textarea", full: true },
);

const WHY = [
  [Truck, "Direct supply", "Stock supplied from our Haldia base."],
  [BadgeCheck, "Growing brand", "Join MHM SUPER ADBLUE early as we expand."],
  [Megaphone, "Partner support", "Work directly with our team on orders and stock."],
  [MapPinned, "Your territory", "We are looking for partners across India."],
];

export default function Franchise() {
  return (
    <>
      <Seo title="AdBlue Dealership & Franchise Enquiry" description="Apply for an MHM SUPER ADBLUE dealership, distributorship or franchise. Partner with a growing AdBlue and lubricants brand from Haldia, West Bengal." />
      <PageHeader testid="franchise-header" eyebrow="Dealer & franchise" lines={["Grow with", { text: "Super AdBlue.", cls: "text-brand" }]} intro="We're building an AdBlue supply and distribution network across India. If you run a fuel station, spares shop or transport business, let's talk." image="/img/real/shop-1.jpg" />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {WHY.map(([Icon, t, d], i) => (
              <Reveal key={t} delay={i * 0.07}>
                <div className="group h-full rounded-[22px] border border-navy/10 bg-[var(--paper)] p-7 transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-navy">
                  <Icon className="h-8 w-8 text-brand" />
                  <h3 className="mt-6 font-display text-2xl font-bold uppercase text-navy transition-colors group-hover:text-white">{t}</h3>
                  <p className="mt-2 text-slate-600 transition-colors group-hover:text-slate-300">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[var(--paper)] pb-24">
        <div className="mx-auto max-w-5xl px-5 lg:px-8">
          <Reveal>
            <div className="clip-notch rounded-[26px] bg-white p-6 sm:p-10 border border-navy/10">
              <p className="eyebrow text-brand">Application</p>
              <h2 className="mt-3 font-display text-4xl font-extrabold uppercase text-navy">Dealer / franchise enquiry</h2>
              <p className="mt-2 mb-8 text-slate-600">Share a few details and our team will reach out.</p>
              <EnquiryForm type="franchise" testPrefix="franchise" fields={FIELDS} submitLabel="Submit application" waText="Hello MHM SUPER ADBLUE, I am interested in a dealership / franchise." />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
